import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule) },
  { path: 'tabs', loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule) },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule) },
  { path: 'signup', loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignupPageModule) },
  { path: 'accessdenied', redirectTo: '', pathMatch: 'full' },
  {
    path: 'project/:id',
    loadChildren: () => import('./pages/features/project-management/project-management.module').then(m => m.ProjectManagementPageModule),
  },
  {
    path: 'project/:id/answer-instance/:answerInstanceId',
    loadChildren: () => import('./pages/features/project-management/project-management.module').then(m => m.ProjectManagementPageModule),
  },
  {
    path: 'project/:projectId/question-modal/:questionId',
    loadChildren: () => import('./pages/modal/question-modal/question-modal.module').then(m => m.QuestionModalPageModule),
  },
  {
    path: 'conclusion',
    loadChildren: () => import('./pages/modal/conclusion/conclusion.module').then(m => m.ConclusionPageModule),
  },
  {
    path: 'signature',
    loadChildren: () => import('./pages/modal/signature/signature.module').then(m => m.SignaturePageModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule),
  },
  {
    path: 'check-list-selection',
    loadChildren: () => import('./pages/modal/check-list-selection/check-list-selection.module').then(m => m.CheckListSelectionPageModule),
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
